export interface LayerConfigDto {
  symbolism?: SymbolismDto;
  heatmap?: HeatMapDto;
  cluster?: ClusterDto;
  label?: LabelDto;
  visualizationStrategy?: VisualizationStrategy;
  classificationKind?: ClassificationKind;
  webMapStyle?: string;
}

export interface SymbolismDto {
  foregroundColor: string;
  foregroundOpacity: number;
  pointSize: number;
}

export interface HeatMapDto {
  availableGradients: { [key: string]: GradientDto };
  allowQualitySelectionInWeb: boolean;
  gradient: GradientDto;
  renderingQuality: string;
  transparencyFactor: number;
  radius: { unit: string; value: number };
}

export interface GradientDto {
  name: string;
  colors: string[];
}

export interface ClusterDto {
  enabled: boolean;
  showClassificationInCluster: boolean;
}

export interface LabelDto {
  enabled: boolean;
  fontSize: number;
  fontColor: string;
  anchor: string;
  offset: OffsetDto;
}

export interface OffsetDto {
  distanceUnit: string;
  horizontal: number;
  vertical: number;
}

export const VisualizationStrategy = {
  SYMBOLISM: 'SYMBOLISM',
  HEATMAP: 'HEATMAP',
  SYMBOLISM_AND_HEATMAP: 'SYMBOLISM_AND_HEATMAP'
} as const;

export type VisualizationStrategy = keyof typeof VisualizationStrategy;

/**
 * Enum for classification kind.
 *
 * @readonly
 * @enum { string }
 * @see src/main/java/net/disy/gis/layer/configuration/atoms/content/classification/ClassificationKind.java
 */
export const ClassificationKind = {
  NONE: 'NONE',
  SIMPLE: 'SIMPLE',
  MULTI: 'MULTI'
} as const;

export type ClassificationKind = keyof typeof ClassificationKind;
